"use strict";

var regexValidator = require('./regexValidator');
var _require = require('./errors'),
  InvalidRevisionError = _require.InvalidRevisionError;
var revisionRegex = /^\d+$/;
var validator = regexValidator(revisionRegex, InvalidRevisionError);
module.exports = function () {
  return {
    validate: function validate(revision) {
      return validator.validate(revision);
    }
  };
};
//# sourceMappingURL=revisionValidtor.js.map